import { createFileRoute } from "@tanstack/react-router";

import PublicPortalPage from "@/components/PublicPortal/PublicPortalPage";

export const Route = createFileRoute("/customer-portal/$public_portal_token/")({
  component: PublicPortalPage,
});
